/**
 * Curated, user-uploaded artifacts grouped by intent so layout pages
 * pull from a single source of truth.
 *
 * `heroes` — large finance-scenery composites suitable as section banners.
 * `brand`  — Sahyog/Noble Infinity branded graphics (logos, value posters).
 * `flyers` — recruitment / loan-product flyers (use on Careers / Partner pages).
 */

const ASSET = "https://customer-assets.emergentagent.com/job_sahyog-finance-1/artifacts";

export const SITE_IMAGES = {
  heroes: [
    // 0 · Global finance + cityscape composite
    `${ASSET}/pzelldg6_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2011_30_17%20PM.png`,
    // 1 · Glass tower with growth chart overlay
    `${ASSET}/bmswp6tf_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2011_32_10%20PM.png`,
    // 2 · Skyline + analytics overlay
    `${ASSET}/s4222izp_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2011_34_03%20PM.png`,
    // 3 · Sunset cityscape + ascending bars
    `${ASSET}/cdtx2tdu_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2011_35_42%20PM.png`,
    // 4 · Modern finance composite
    `${ASSET}/ndnevxga_ChatGPT%20Image%20Jun%2030%2C%202026%2C%2011_59_11%20PM.png`,
    // 5 · Wealth + technology composite
    `${ASSET}/usghahlv_file_00000000595471fa9fa148af10a92abb.png`,
    // 6 · Investment growth composite
    `${ASSET}/l0hce66x_ChatGPT%20Image%20Jun%2027%2C%202026%2C%2008_10_39%20PM.png`,
    // 7 · Global advisory composite
    `${ASSET}/cw5c9fg8_ChatGPT%20Image%20Jun%2027%2C%202026%2C%2005_30_27%20PM.png`,
    // 8 · Sustainable finance composite
    `${ASSET}/6cst1khe_ChatGPT%20Image%20Jun%2027%2C%202026%2C%2010_42_06%20AM.png`,
    // 9 · Wealth management composite
    `${ASSET}/rjiuo4o4_ChatGPT%20Image%20Jun%2027%2C%202026%2C%2005_30_33%20PM.png`,
    // 10 · Corporate finance composite
    `${ASSET}/i3395s41_ChatGPT%20Image%20Jun%2027%2C%202026%2C%2010_57_50%20AM.png`,
  ],
  brand: {
    valuesPoster: `${ASSET}/2f4r77xk_WhatsApp%20Image%202026-06-30%20at%2011.12.38%20PM.jpeg`,
    founderBanner: `${ASSET}/hmienapq_WhatsApp%20Image%202026-06-30%20at%2010.50.24%20PM.jpeg`,
  },
  flyers: {
    partnerProgram: `${ASSET}/q7kmws5l_IMG-20260629-WA0001.jpg`,
    loanProducts: `${ASSET}/1y06z5dl_WhatsApp%20Image%202026-06-28%20at%2012.20.52%20AM.jpeg`,
    advisorProgram: `${ASSET}/zth4nzgo_WhatsApp%20Image%202026-06-27%20at%206.19.01%20PM.jpeg`,
    loanProductsAlt: `${ASSET}/ppk5a8du_WhatsApp%20Image%202026-06-28%20at%2012.20.54%20AM.jpeg`,
    loanProductsAlt2: `${ASSET}/f0d9hrxx_WhatsApp%20Image%202026-06-28%20at%2012.20.54%20AM%20%281%29.jpeg`,
    bigPoster: `${ASSET}/8u245zf3_WhatsApp%20Image%202026-06-28%20at%2012.20.55%20AM.jpeg`,
    bigPosterAlt: `${ASSET}/dzi5nv5y_WhatsApp%20Image%202026-06-28%20at%2012.20.55%20AM%20%281%29.jpeg`,
    walkthrough: `${ASSET}/j0g85ys7_WhatsApp%20Image%202026-06-27%20at%208.56.16%20PM.jpeg`,
  },
};
